import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetUserGameDetails } from "../../helpers/api";
import Spinner from "../../components/Spinner";
import Avatar from "../../assets/icons/Avatar.svg";
import Table from "../../components/table/table";

const GameDetailsByUser = () => {
  const { id } = useParams();
  const [gameDetailsUser, setGameDetailsUser] = useState("rr");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;

      try {
        setLoading(true);

        const response = await GetUserGameDetails(id);


        setGameDetailsUser(response.data);
      } catch (error) {
        console.error("Error getting user game details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const columns = [
    {
      label: "Type",
      key: "type",
    },
    {
      label: "Date de création",
      key: "createdAt",
      customRenderers: (row) => (
        <div>
          {row.createdAt
            ? new Date(row.createdAt).toLocaleDateString("fr-FR")
            : "-"}
        </div>
      ),
    },
    {
      label: "Date d'utilisation",
      key: "order",
      customRenderers: (row) => (
        <div>
          {row.usedAt ? new Date(row.usedAt).toLocaleDateString("fr-FR") : "-"}
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="bg-white border border-[#EEEEEE] w-full p-4 rounded-[10px] flex flex-col items-start gap-3">
        <h2 className="h2-title">Informations Générales</h2>
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center justify-start gap-4 w-1/2 ">
            <img
              className="border-4 rounded-full border-[#20C374]"
              src={Avatar}
              width={50}
              height={50}
              alt="Avatar User"
            />
            <div className="flex flex-col items-start">
              <div className="text-[#A5A5A5] text-[12px] font-semibold">ID</div>
              <div className="text-[16px] text[#000]">
                {gameDetailsUser.order}
              </div>

              <div className="text-[#A5A5A5] text-[12px] font-semibold mt-2">
                Nom & Prénom
              </div>
              <div className="text-[16px] text[#000]">
                {gameDetailsUser.lastName} {gameDetailsUser.firstName}
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start  border-l pl-4 border-[#EEEEEE] w-1/2 ">
            <div className="text-[#A5A5A5] text-[12px] font-semibold">
              Balance
            </div>
            <div className="text-[16px] text[#000]">
              {gameDetailsUser.game?.balance ?? "-"}
            </div>

            <div className="flex w-full  items-center justify-between  mt-2">
              <div className="flex flex-col items-start ">
                <div className="text-[#A5A5A5] text-[12px] font-semibold ">
                  Pack
                </div>
                <div className="text-[16px]">
                  {gameDetailsUser.game?.pack ?? "-"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {gameDetailsUser.gifts && (
        <div className="bg-white border border-[#EEEEEE] w-full p-4 rounded-[10px]">
          <Table
            data={gameDetailsUser.gifts}
            message="Aucun cadeau pour le moment"
            columns={columns}
            loading={loading}
            titleTable="Détails des cadeaux"
          />
        </div>
      )}
    </div>
  );
};

export default GameDetailsByUser;
